export const commissionSlabReducer = (state = { loading: false }, action) => {
  switch (action.type) {

    case "ADD_COMMISSION_SLAB_REQUEST":
      return { ...state, loading: true };

    case "ADD_COMMISSION_SLAB_SUCCESS":
      return { ...state, loading: false };

    case "ADD_COMMISSION_SLAB_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "UPDATE_COMMISSION_SLAB_REQUEST":
      return { ...state, loading: true };

    case "UPDATE_COMMISSION_SLAB_SUCCESS":
      return { ...state, loading: false };

    case "UPDATE_COMMISSION_SLAB_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "GET_COMMISSION_SLAB_REQUEST":
      return { ...state, loading: true, commissionSlab: null };

    case "GET_COMMISSION_SLAB_SUCCESS":
      return { ...state, loading: false, commissionSlab: action.payload };

    case "GET_COMMISSION_SLAB_FAILED":
      return { ...state, loading: false, commissionSlab: null, error: action.payload };

    case "LIST_COMMISSION_SLAB_REQUEST":
      return { ...state, loading: true, commissionSlabList: null };

    case "LIST_COMMISSION_SLAB_SUCCESS":
      return { ...state, loading: false, commissionSlabList: action.payload };

    case "LIST_COMMISSION_SLAB_FAILED":
      return { ...state, loading: false, commissionSlabList: null, error: action.payload };

    case "LIST_PROJECTS_WITH_SLAB_REQUEST":
      return { ...state, loading: true, projectsWithSlabList: null };

    case "LIST_PROJECTS_WITH_SLAB_SUCCESS":
      return { ...state, loading: false, projectsWithSlabList: action.payload };

    case "LIST_PROJECTS_WITH_SLAB_FAILED":
      return { ...state, loading: false, projectsWithSlabList: null, error: action.payload };
      
    default:
      return state;
  }
};